import { Component, OnInit, OnDestroy } from '@angular/core';
import { ScreeningService } from '../services/screening.service';
import { AuthService } from '../services/auth.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ScreeningInvite } from '../models/screeningInvite';
import { ChannelService, ChannelEvent } from '../services/channel.service';
import { ApplicantDataService } from '../services/applicant-data.service';
import { Subject, Subscription } from 'rxjs';
import { ScreeningLog, LogParserType } from '../models/LogEntry';

@Component({
  selector: 'app-final-screen-app-pay',
  templateUrl: './final-screen-app-pay.component.html',
  styleUrls: ['./final-screen-app-pay.component.less']
})
export class FinalScreenAppPayComponent implements OnInit,OnDestroy {
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
  token: string;
  screeningInvitation : ScreeningInvite;

  listner$ : Subject<any>;
  sub : Subscription;
  constructor( private applicantData : ApplicantDataService, private screen : ScreeningService, private location: Router, private auth : AuthService, private activatedRoute: ActivatedRoute, private channels : ChannelService) {
    this.auth.titleBarText = "Thank your for Screening";
    this.channels.starting$.subscribe(e=>{
      let evt = new ChannelEvent();
      evt.channelName = "JoinGroup";
      evt.data = this.token;
      this.channels.publish(evt);
  
      
      
    });

    this.listner$ = this.applicantData.inviteFetched;
    this.sub = this.listner$.subscribe((d: any)=>{
      if(this.applicantData.screeningInvite.applicantReview)this.location.navigateByUrl('/review-wait');
    });
   
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(
      (params: ParamMap) =>{
        this.token = params.get('token');
        this.applicantData.token = this.token;
        this.screen.screeningToken = this.token;
        this.applicantData.FetchApplicantInviteAppPay()
        // this.channels.start();
    // TODO: start listening on this token
   
        // this.auth.pos.screetLoginRedirect = '/packages/'+this.clientId;
        // if(!localStorage.getItem('STP-JWT')){
        //   this.auth.hasRedirect = true;
        //   this.location.navigateByUrl('/auth')
        // }else {
        //   // this.auth.GetUsersRoles();
        //   // this.screen.getApplicantInvite(this.token).subscribe((ev: ScreeningInvite) => {
        //   //   this.screeningInvitation = ev;
        //   // });
        // }
      });
  }
  
}
